module.exports = __webpack_public_path__ + "img/DragAndDrop.54b0b16d.png";